import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=abc4a8b0&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc4a8b0",
  null
  
)

export default component.exports